export enum LikeTypeEnum {
    Event = "Event",
    EventPhoto = "EventPhoto",
    EventAlbum = "EventAlbum",
    MessagePhoto = "MessagePhoto"
}
